import { styled } from '@mui/material/styles'

export const SuccessMessage = styled('p')`
	background-color: #d4edda; /* Light green background */
	color: #155724; /* Dark green text */
	border: 1px solid #c3e6cb; /* Light green border */
	padding: 20px;
	border-radius: 5px;
	font-family: 'Sora', sans-serif;
	max-width: 400px;
	margin: 20px auto;
	text-align: center;
`
